export function getLiveMatchWindowLocationHash(sportId, countryId, tournamentId, matchId) {
	return "#"+[sportId,countryId,tournamentId,matchId].join('_')
}
